import React, { useState } from 'react'
import { Radio } from 'antd'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { segmentApi } from '@edulastic/api'
import {
  AI_QUESTION_UPDATE_TYPES,
  QUESTION_CONVERT_TYPE_OPTIONS,
} from '../constants/form'
import AIContentView from '../common/AIContentView'
import {
  enhanceAIQuestionAction,
  getAIEnhanceQuestionState,
} from '../ducks/enhanceQuestion'
import { titleToAIQuestionType } from '../utils/form'
import QuestionView from '../common/QuestionView'
import AIEnhanceQuestionFooterAction from './AIEnhanceQuestionFooterAction'
import {
  StyledAIEnhanceQuestionContainer,
  StyledOriginalQuestionText,
  StyledRadioButtonContainer,
  StyledRadioGroupContainer,
} from '../common/styled'
import {
  getAIEnhanceExistingQuestionPayloadData,
  transformPAQuestionToAIQuestion,
} from '../utils/common'

export const AIQuestionConvertType = ({
  aiEnhanceQuestionState,
  enhanceAIQuestion,
  data: { question } = {},
  onFinish,
  onUseOldQuestion,
  onAIResponseFeedbackSubmit,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    QUESTION_CONVERT_TYPE_OPTIONS[0].value
  )

  const { apiStatus, result } = aiEnhanceQuestionState || {}
  const { updatedQuestionMetaData: { updatedQuestionQType } = {} } =
    result || {}
  const { title = '' } = question || {}
  const questionType = titleToAIQuestionType(title)

  const onGenerate = (reGenerate = false) => {
    enhanceAIQuestion({
      type: AI_QUESTION_UPDATE_TYPES.CONVERT,
      questionType,
      existingQuestion: getAIEnhanceExistingQuestionPayloadData({
        question,
        questionType,
      }),
      options: { convertType: selectedOption },
    })
    segmentApi.genericEventTrack(
      `TestReview:AI${
        reGenerate === true ? 'Regenerate' : 'Generate'
      }Question': '`,
      {
        type: AI_QUESTION_UPDATE_TYPES.CONVERT,
        questionType,
        convertTypeTo: selectedOption,
      }
    )
  }

  const handleUseRevisedQuestion = () => {
    onFinish({
      question: result?.updatedQuestion || {},
      questionType: updatedQuestionQType,
      selectedOption,
    })
  }

  return (
    <>
      <StyledAIEnhanceQuestionContainer>
        <StyledOriginalQuestionText>
          Original Question
        </StyledOriginalQuestionText>
        <QuestionView
          question={transformPAQuestionToAIQuestion(question)}
          questionType={questionType}
        />
        <b>How do you want to convert it?</b>
        <StyledRadioGroupContainer>
          <Radio.Group
            onChange={({ target }) => setSelectedOption(target.value)}
            value={selectedOption}
          >
            {QUESTION_CONVERT_TYPE_OPTIONS.map(({ value, label }) => {
              if (value === questionType) {
                return null
              }
              return (
                <StyledRadioButtonContainer>
                  <span data-cy={value}>
                    <Radio value={value}>{label}</Radio>
                  </span>
                  <br />
                </StyledRadioButtonContainer>
              )
            })}
          </Radio.Group>
        </StyledRadioGroupContainer>
        {apiStatus && (
          <AIContentView
            onRegenerate={() => onGenerate(true)}
            title=""
            loadingTitle="Generating Question"
            content={
              <QuestionView
                question={result?.updatedQuestion || {}}
                questionType={updatedQuestionQType}
              />
            }
            status={apiStatus}
            showAIResponseFeedback
            onAIResponseFeedbackSubmit={onAIResponseFeedbackSubmit}
          />
        )}
      </StyledAIEnhanceQuestionContainer>
      <AIEnhanceQuestionFooterAction
        status={apiStatus}
        onGenerate={onGenerate}
        onFinish={handleUseRevisedQuestion}
        onUseOldQuestion={() => onUseOldQuestion({ selectedOption })}
      />
    </>
  )
}

const enhance = compose(
  connect(
    (state) => ({
      aiEnhanceQuestionState: getAIEnhanceQuestionState(state),
    }),
    {
      enhanceAIQuestion: enhanceAIQuestionAction,
    }
  )
)

export default enhance(AIQuestionConvertType)
